
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/spravy-zo-zjazdovky",
      function () {
        return require("private-next-pages/[region]/[resort]/spravy-zo-zjazdovky.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/spravy-zo-zjazdovky"])
      });
    }
  